import React, { useState } from "react";
import "./component.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import SingingContract from "../../../assests/SingingContract.svg";
import { Button, Box, TextField } from "@mui/material";
import leftArrow from "../../../assests/leftArrow.svg";
import { Link, useNavigate, useHistory } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoadingSpinner from "../../Loading/component";
import { CouponSuccessComponent } from "../CouponSuccess/component";
import { CouponComponent } from "../CouponCreate/component";

export const CouponDeviceLimitComponent = ({
  couponCreationStep15,
  couponLimit,
  handleChangeCouponLimit,
 
}) => {
 
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };
  const goback = () => {
    navigate(-1);
  };
 

  return (
    <>
     

      <div>
       
          <>
            <div className="main-div">
              <div>
                <Sidebar />
              </div>

              <div>
                <div
                  style={{
                    marginLeft: "42px",
                    marginTop: "20px",
                    width: "400px",
                  }}
                >
                  <h2>
                    <img
                      onClick={handleClick}
                      style={{ width: "22px", cursor: "pointer" }}
                      src={leftArrow}
                      alt=""
                    />{" "}
                    Create Coupon
                  </h2>
                </div>

                <div className="bDetrails-div">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      width: "1328px",
                    }}
                  >
                    <div className="inputDiv">
                      <Box
                        sx={{
                          width: 600,
                          maxWidth: "100%",
                          alignItems: "center",
                        }}
                      >
                        <label
                          htmlFor=""
                          className="couponLabel"
                          style={{ width: "1090px" }}
                        >
                          How many time a Device can use the coupon?
                        </label>
                        <div>
                          <>
                            <TextField
                              style={{
                                margin: "18px",
                                padding: "0px",
                                color: "#b2b2b2",
                              }}
                              fullWidth
                              label="Usage Limit"
                              type="number"
                              value={couponLimit}
                              onChange={handleChangeCouponLimit}
                            />
                          </>
                        </div>

                           <Box className="usersrolebtn" >
            <Button className="backbtn" onClick={goback}>
              Cancel
            </Button>

        

            <Button
            variant="contained"
           onClick={(e)=>{couponCreationStep15(e)}}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
          </Box>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        
       
       
        
        
     
      </div>
    </>
  );
};
